const AUTH_TOKEN = "HADLEY_APP_authToken"

export type SessionContext = "novus" | "org-admin"

export const getSessionToken = (context: SessionContext) => {
  return sessionStorage.getItem(`${AUTH_TOKEN}-${context}`)
}
export const setSessionToken = (context: SessionContext, token: string) => {
  sessionStorage.setItem(`${AUTH_TOKEN}-${context}`, token)
}
export const removeSessionToken = (context: SessionContext) =>
  sessionStorage.removeItem(`${AUTH_TOKEN}-${context}`)
